export const STRUCTURES = {
    sole: 'Sole trader',
    partnership: 'Partnership',
    limited: 'Limited company or LLP'
}